import { useEffect, useState, useContext, useCallback } from "react";
import { CheckInContext } from "../context/checkin";
import { UserContext } from "../context/user";
// import { useNavigate } from 'react-router-dom';
// import { HotelContext } from "../context/hotel";

export const useSessionPersistence = () => {
    // const navigate = useNavigate();
    // const { getUrlPath } = useContext(HotelContext);
    const { identify } = useContext(CheckInContext)
    const { stayConfirmInit } = useContext(UserContext)
    const [ sessionId, setSessionId ] = useState(null);

    useEffect(() => {
        console.log('1312 - Check Session Persistence');

        console.log('1312 - Check Session Persistence - window.location', window.location);

        if (window?.location?.search && window.location.search.indexOf('sessionId=') !== -1) {
            const _sessionId = window.location.search.replace('?sessionId=', '');
            console.log('1312 - _sessionId', _sessionId)
            setSessionId(_sessionId)
        }

    }, [])

    // useEffect(() => {
    //     if (!sessionId) return;

    //     const _arr = sessionId.split('_');
    //     const checkInId = _arr[0];
    //     const reservationCode = _arr[1];
    //     alert(reservationCode)
    //     if (reservationCode) {
    //         alert(stayConfirmInit)
    //         alert(identify)
    //         if (identify) {
    //             alert('GO')
    //             identify(reservationCode)
    //                 .then(() => {
    //                     alert("Si")
    //                     stayConfirmInit()
    //                     // navigate(getUrlPath('/home'), { replace: true })
    //                 })
    //                 .catch(err => {
    //                     alert("no")
    //                     console.error('0712 - err', err.message)
    //                 })
    //         }
    //     }
    // }, [ sessionId ])


    // WORKAROUND QUE NO ANDA
    // React.useEffect(() => {
    //     // alert(ip)
    //     if (location.search && location.search.indexOf('sessionId=') !== -1) {
    //         const _sessionId = location.search.replace('?sessionId=', '');
    //         const _arr = _sessionId.split('--');
    //         const deviceId = decodeBase64(_arr[0]);
    //         const reservationCode = decodeBase64(_arr[1]);
    //         if (deviceId && checkIn?.externalId !== reservationCode) {
    //             console.log('identifing -- todo validar deviceId');
    //             identify(reservationCode);
    //         }
    //     }
    // }, [ location?.search ])
    // ------------------------

    // const sessionViewer = () => {
    //     console.log('0812 - Check Session Persistence - check');
    //     return <p>sessionId: {sessionId}</p>
    // }

    return {
        sessionId
    }

}